// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host {\n  height: 80%;\n  display: flex;\n  flex-direction: column;\n}\n:host h1 {\n  padding: 8px;\n  padding-left: 24px;\n  font-size: 24px;\n}\n:host .dialog-content {\n  width: 80%;\n  margin-left: 0;\n  flex-grow: 1;\n}\n:host .dialog-actions {\n  justify-content: flex-end;\n  padding-right: 8px;\n  align-self: flex-end;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
